import React from "react";
import styled from "styled-components";
import { ButtonIcon, ButtonText, InputTypeAhead } from "@loanbossinc/component-library";

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 956px;
`;
const DataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 956px;
    height: 903px;
    background: #C4C4C4;
    margin-top: 16px;
    padding: 16px;
`;
const DataRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 867px;
    height: 54px;

    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    align-items: center;
    padding: 16px;
    justify-content: space-between;
`;
const DataRowWithMargin = styled(DataRow)`
    margin-bottom: 16px;
`;
const CompanyName = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 56px;
    display: flex;
    align-items: center;

    color: #000000;
`;
const StyledButtonText = styled(ButtonText)`
  && {
    display: flex;
    justify-content: 'flex-start';
    .label {
      margin-left: 14px;
    }
  }
`;
const Title = styled.div`
    width: 523px;
    height: 57px;

    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;

    color: #000000;
`;
const AddLabel = styled.div`
    width: 215px;
    height: 54px;

    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;

    color: #000000;
`;
const ScrollWrapper = styled.div`
    overflow-y: auto;
`;

export default function CompanySponsors(props) {
  if (!props || !props.company) {
    return null;
  }

  return (
    <PageWrapper>

      <CompanyName>{props.company.name}</CompanyName>
      <DataWrapper>
        <Title>Authorized Sponsor Company List</Title>
        <AddLabel>ADD NEW</AddLabel>
        <DataRowWithMargin>
          <InputTypeAhead
            id="sponsorCompanyId"
            name="sponsorCompanyId"
            label="Sponsor Company"
            style={{ "width": "718px" }}
            options={props.sponsorCompanies}
            displayWith={option => option && option.name}
            setValueWith={option => option && option.id}
            onChange={props.handleCompanySelect}
            className="input"
          />
          <StyledButtonText
            style={{ marginLeft: "102px" }}
            iconName={"add_circle"}
            onClick={props.addCompany}
            reverse={false}
          />
        </DataRowWithMargin>
        <ScrollWrapper>
          {props.company.sponsorCompanies.map(x => (
            <DataRow>
              {x.name}
              <ButtonIcon hasBorder={false} iconName="highlight_off" onClick={() => props.removeCompany(x.id)} />
            </DataRow>
          ))}
        </ScrollWrapper>
      </DataWrapper>

    </PageWrapper>
  );
}
